import React, { createContext, useState, useContext, useEffect } from "react";
import api from "../Api";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [username, setUsername] = useState(
    localStorage.getItem("username") || "",
  );
  const [token, setToken] = useState(() => localStorage.getItem("token") || "");

  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (token) {
      fetchUserProfile();
    }
  }, [token]);

  const fetchUserProfile = async () => {
    try {
      const BASE_URL = process.env.REACT_APP_API_URL;

      const [profileRes] = await Promise.all([
        api.get(`/auth/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const profileData = profileRes.data;
      setUserProfile(profileData);

      localStorage.setItem("userProfile", JSON.stringify(profileData));
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        logoutUser();
      } else {
        console.error("Failed to fetch profile:", err);
      }
    }
  };

  const loginUser = (decodedUser, userToken) => {
    setUsername(decodedUser.username);
    setToken(userToken);

    localStorage.setItem("token", userToken);
    localStorage.setItem("username", decodedUser.username);
    localStorage.setItem("userProfile", JSON.stringify(decodedUser));

    setUserProfile(decodedUser);
  };

  const logoutUser = () => {
    setUsername("");
    setToken("");
    setUserProfile(null);
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("userProfile");
  };

  const updateUserProfile = () => {
    fetchUserProfile();
  };

  const value = React.useMemo(() => ({
    username,
    token,
    userProfile,
    fullName: userProfile
      ? `${userProfile.Fname || ""} ${userProfile.Lname || ""}`.trim()
      : "",
    role: userProfile?.role_name || "",
    loginUser,
    logoutUser,
    updateUserProfile,
  }), [username, token, userProfile, loginUser, logoutUser, updateUserProfile]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
